/* eslint-disable react-hooks/exhaustive-deps */
import { useLayoutEffect, useState } from "react";
import { Layout, Card, Table, Button, DatePicker } from "antd";

import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import dayjs from "dayjs";

import { getAPI } from "../../../utils/common";
import {
  KITCHEN_DAILY_STOCK_REPORT,
  KITCHEN_PDF_STOCK_REPORT,
} from "../../../constants/api";

const { Content } = Layout;

function KitchenDailyStockReport() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    getAPI(
      KITCHEN_DAILY_STOCK_REPORT,
      (res) => {
        if (res.status) {
          setData(res.data);
          setFilteredData(res.data);
        }
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  // 📅 Single Date Filter
  const handleDateFilter = (date) => {
    if (!date) {
      setFilteredData(data);
      return;
    }

    const selectedDate = dayjs(date);

    const filtered = data.filter((item) =>
      dayjs(item.report_date).isSame(selectedDate, "day"),
    );

    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, i) => i + 1,
    },
    {
      title: "Report Date",
      dataIndex: "report_date",
      filters: [
        { text: "Today", value: "today" },
        { text: "Last 7 Days", value: "last7" },
        { text: "This Month", value: "month" },
      ],
      onFilter: (value, record) => {
        const date = dayjs(record.report_date);

        if (value === "today") {
          return date.isSame(dayjs(), "day");
        }
        if (value === "last7") {
          return date.isAfter(dayjs().subtract(7, "day"));
        }
        if (value === "month") {
          return date.isSame(dayjs(), "month");
        }
        return true;
      },
      render: (v) => (v ? dayjs(v).format("DD MMM YYYY") : "-"),
    },
    {
      title: "Generated At",
      dataIndex: "created_at",
      render: (v) => (v ? dayjs(v).format("DD MMM YYYY, hh:mm A") : "-"),
    },
    {
      title: "View",
      dataIndex: "id",
      render: (id) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              const encodedId = btoa(id.toString());
              const url = `${KITCHEN_PDF_STOCK_REPORT}${encodedId}`;
              window.open(url, "_blank");
            }}
          >
            Export PDF
          </Button>
        );
      },
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Daily Stock Report"
          extra={
            <DatePicker
              onChange={handleDateFilter}
              style={{ marginBottom: 16 }}
            />
          }
        >
          <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenDailyStockReport;
